import Vue from 'vue'
import { Dialog } from 'vant'
import axios from 'axios'
import VConsole from 'vconsole/dist/vconsole.min.js' //引入Vconsole

function analyzParams(param_name) {
	let url = window.location.href.split('?')[1]
  if (url == '' || url == undefined) return url
  url = url.split(param_name + '=')[1]
  if (url == '' || url == undefined) {
    url = ''
    return url
  }
  if (url.indexOf("&") > 0) {
    url = url.split("&")[0]
  }
  return url
}
/*初始化getServerConfig
*1、获取JSON配置信息
*2、根据code获取当前用户信息
*3、返回后初始化vue实例
*params
        **UserUrl
        **appName
        **callback
*
*/
export function getServerConfig(userURL,appName,callBack){
    return new Promise((resolve, reject) => {
        axios.get('./static/serverConfig.json').then(result => {
        let config = result.data;
        if(config.isVconsole==true){ let vConsole = new VConsole()}
            for (let key in config) {
                Vue.prototype[key] = config[key];
            }
            //获取用户信息
            getUserInfo(config.baseURL+userURL,appName,resolve,callBack)
        })
    })
}
function getUserInfo(url,appName,resolve,callBack){
  // try {
  //   axios.get(url,{params: {appName: appName, code: analyzParams('code')}}).then(res=>{
  //     res=res.data;
  //     if(res.error_code!==0) {console.log('获取用户信息失败');resolve();}
  //     else{
  //       sessionStorage.userId = res.data.userid;
  //       sessionStorage.userInfo = JSON.stringify(res.data);
  //       resolve();
  //       callBack?callBack(res):''
  //     }
  //   })
  // } catch (err) {
  //   console.log(err)
  // }

  if (!sessionStorage.userId && process.env.NODE_ENV == 'production') {
    try {
      axios.get(url,{params: {appName: appName, code: analyzParams('code')}}).then(res=>{
        res=res.data;
        if(res.error_code!==0) {console.log('获取用户信息失败');resolve();}
        else{
          sessionStorage.userId = res.data.userid;
          sessionStorage.userInfo = JSON.stringify(res.data);
          resolve();
          callBack?callBack(res):''
        }
      })
    } catch (err) {
      console.log(err)
    }

  }else{
    if(process.env.NODE_ENV !== 'production' ) {
      sessionStorage.userInfo=JSON.stringify({"id":"64dd953ba102418aa83fac2a3c64361a","userid":"13505160093","name":"徐庆斌","alias":null,"mobile":"15010423121","department":[4,3,7],"order":[null,null,null],"position":"","gender":2,"email":"","telephone":null,"is_leader_in_dept":[null,null,null],"avatar":"","enable":1,"address":null,"isleader":1,"weixin":null,"organizes":[{"id":4,"name":"开发部","parentid":2,"order":99999000,"depId":null,"users":null,"children":null,"avatar":"https://static.zhangwin.com/img/depAvatar.svg"},{"id":3,"name":"测试部","parentid":2,"order":100000000,"depId":null,"users":null,"children":null,"avatar":"https://static.zhangwin.com/img/depAvatar.svg"},{"id":7,"name":"产品部","parentid":2,"order":99996000,"depId":null,"users":null,"children":null,"avatar":"https://static.zhangwin.com/img/depAvatar.svg"}]})
    }
    resolve();
  }
}



// WEBPACK FOOTER //
// ./src/utils/permission.js